import React, { Component } from 'react'
import QrReader from 'react-qr-reader'
import Button from '../../elements/Button/Button'
import { Icon } from '../../elements/Icon'
import { Container, Close, QrReaderContainer } from './styles'

class QRCodeReader extends Component {
  setIsOpen = status => this.props.setIsOpen(status)

  handleScan = data => {
    if (data) {
      const { onScan } = this.props
      onScan && onScan(data)
      this.setIsOpen(false)
    }
  }

  handleError = err => {
    console.error(err)
    this.setIsOpen(false)
  }

  render() {
    return (
      <Container>
        <Button
          buttonType="skyBlue"
          text="Coletar TAG por QRCode"
          onClick={() => this.setIsOpen(true)}
          id="btnQRCode"
        />
        {this.props.isOpen && (
          <QrReaderContainer>
            <Close onClick={() => this.setIsOpen(false)}>
              <Icon icon="modal-close" height="31.2px" width="31.2px" viewBox="0 0 24 24" />
            </Close>
            <QrReader
              delay={300}
              onError={this.handleError}
              onScan={this.handleScan}
              style={{ width: '100%', height: '100%' }}
            />
          </QrReaderContainer>
        )}
      </Container>
    )
  }
}

export default QRCodeReader



// WEBPACK FOOTER //
// ./src/app/modules/QRCodeReader/index.js